module.exports = "/wp-content/plugins/farmacy/assets/js/images/video-play-button-f85509f3f5412ae80265d64dda187dc4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/video-group/video-item/img/video-play-button.png
 ** module id = 404
 ** module chunks = 1 16 107 119 152
 **/